/* Built In Imports */
/* External Imports */
import { Box, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */

/* Services */

/**
 * Renders the SectionTitle component.
 *
 * @param titleObj.titleObj
 * @param {object} titleObj component.
 * @param {object} rest some more data
 * @param titleObj.section
 * @returns {ReactElement} SectionTitle component.
 */
export default function TwolineTitle({ titleObj, region, lang }) {
  return (
    <>
      <Box
        mx="auto"
        fontFamily={'FedraSansStd-A-medium'}
        lineHeight={{
          base: '30px',
          md: '30px',
        }}
        color={'#000000'}
        textAlign={'center'}
        mt={'30px'}
        fontWeight={'500'}
      >
        <Box as="h2" pb={'15px'} w={'100%'} mx={'0'}>
          <Text fontSize={{ base: '30px', md: '30px', lg: '30px' }}>
            {titleObj[0]?.text}
          </Text>
          <Text fontSize={{ base: '24px', md: '24px', lg: '24px' }}>
            {titleObj[1]?.text}
          </Text>
        </Box>
      </Box>
    </>
  );
}
